import { baseUrl, handleResponse, handleError, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/MyOptions";

export function getMyStatement() {
    return fetch(`${apiUrl}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getExercisedOptions() {
    return fetch(`${apiUrl}/exercised`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getMyStatementForActivity() {
    return fetch(`${apiUrl}/Statement/Activity`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmpStatement(employeeId) {
    return fetch(`${apiUrl}/${employeeId}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmpStatementForActivity(employeeId) {
    return fetch(`${apiUrl}/${employeeId}/Statement/Activity`, GetHeaders()).then(handleResponse).catch(handleError);
}